import { Routes } from '@angular/router';
import { Login } from './login/login';
import { Register } from './register/register';
import { ForgotPassword } from './forgot-password/forgot-password';
import { VerifyCode } from './verify-code/verify-code';
import { ResetPassword } from './reset-password/reset-password';
import { AuthGuard } from '../shared/services/auth.guard';


export const authRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        component: Login,
      },
      {
        path: 'register',
        component: Register,
      },
      {
        path: 'forgot-password',
        component: ForgotPassword,
      },
      {
        path: 'verify-code',
        component: VerifyCode,
      },
      {
        path: 'reset-password',
        component: ResetPassword,
        canActivate: [AuthGuard],
      },
      { path: '**', redirectTo: 'login' },
    ],
  },
  // Fallback when no prior route is matched
  { path: '**', redirectTo: 'login' },
];
